<template>
  <v-row>
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <v-col cols="12">
      <b-card header-bg-variant="secondary" header-text-variant="light">
        <template v-slot:header>
          <v-row>
            <v-col cols="12" class="mt-4">
              <h4>شرح فارسی: {{ itemInfo.identifierFa }}</h4>
              <h4 dir="ltr" style="text-align: left">
                English Description: {{ itemInfo.identifierEn }}
              </h4>
              <h5>موجودی: {{ itemInfo.sum }} {{ itemInfo.measurementUnit }}</h5>
            </v-col>
          </v-row>
        </template>
        <loading v-if="vLoading" />
        <b-tabs pills card content-class="mt-3">
          <b-tab title="عمومی" active>
            <b-card>
              <v-btn class="mb-4 purple white--text" @click="openEditDialog()">
                ویرایش
              </v-btn>
              <table class="orderInfoTable" border="1px" style="width: 100%">
                <tbody>
                  <tr v-for="field in fieldsFull" :key="field.key">
                    <td style="text-align: center">
                      <strong>{{ field.label }}</strong>
                    </td>
                    <td style="text-align: center">
                      {{ itemInfo[field.key] }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <strong>نوع کالا: </strong>
                    </td>
                    <td style="text-align: center">
                      <a
                        :href="'/warehouse/' + type.slug + 's'"
                        target="_blank"
                        >{{ type.name }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>
          </b-tab>

          <b-tab title="کاردکس عمومی" v-if="itemInfo.allExchanges">
            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="itemInfo.allExchanges"
              :fields="allExchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <b-button
                    class="mx-1"
                    variant="primary"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="submitCorrection(row.item, row.item.warehouseId)"
                    >اصلاح سند
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="success"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="approve(row.item)"
                    >تایید نهایی
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="danger"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="askDelete(row.item)"
                    >حذف تراکنش
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="warning"
                    v-if="row.item.status == 'تایید نهایی'"
                    @click="needEdit(row.item)"
                    >نیاز به اصلاح
                  </b-button>
                </div>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentExchangePage"
              :total-rows="itemInfo.allExchanges.length"
              :per-page="ExchangePerPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-tab>

          <b-tab title="کاردکس به ازای انبار" v-if="itemInfo.exchanges">
            <b-card
              v-for="warehouse in itemInfo.exchanges"
              :key="warehouse.warehouseId"
              header-bg-variant="light"
              header-text-variant="dark"
              bg-variant="white"
            >
              <template v-slot:header>
                <h5>
                  رسید و حواله‌های ماده اولیه در انبار
                  <a
                    :href="'/warehouse/profile/' + warehouse.warehouseId"
                    target="_blank"
                  >
                    <strong>{{ warehouse.warehouseName }}</strong>
                  </a>
                </h5>
                <h6>موجودی کل در این انبار: {{ warehouse.sum }}</h6>
              </template>

              <b-table
                responsive
                show-empty
                id="detailsTable"
                :items="warehouse.allExchanges"
                :fields="exchangesFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 + perPage * (currentPage - 1) }}
                  </div>
                </template>
                <template v-slot:cell(operation)="row">
                  <b-button
                    v-if="row.item._showDetails"
                    variant="danger"
                    @click="row.toggleDetails"
                    >بستن
                  </b-button>
                  <b-button v-else variant="primary" @click="row.toggleDetails"
                    >عملیات
                  </b-button>
                </template>

                <template #row-details="row">
                  <div
                    class="animated fadeIn"
                    style="text-align: center; vertical-align: middle"
                  >
                    <b-button
                      class="mx-1"
                      variant="primary"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="submitCorrection(row.item, warehouse.warehouseId)"
                      >اصلاح سند
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="success"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="approve(row.item)"
                      >تایید نهایی
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="danger"
                      v-if="row.item.status != 'تایید نهایی'"
                      @click="doDelete(row.item)"
                      >حذف تراکنش
                    </b-button>
                    <b-button
                      class="mx-1"
                      variant="warning"
                      v-if="row.item.status == 'تایید نهایی'"
                      @click="needEdit(row.item)"
                      >نیاز به اصلاح
                    </b-button>
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-pagination
                v-model="currentExchangePage"
                :total-rows="itemInfo.exchanges.length"
                :per-page="ExchangePerPage"
                aria-controls="detailsTable"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
              <br />
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>
    </v-col>
    <v-dialog v-model="editExchangeModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            {{ selectedExchange }}
            <b-form-group label="تاریخ رسید / حواله">
              <date-picker v-model="edit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت  رسید / حواله">
              <date-picker
                v-model="edit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-select
              label="انبار طرف"
              :items="warehouses"
              v-model="selectedExchangeWarehouse"
              outlined
              dense
              item-text="name"
              item-value="id"
              disabled
            />
            <v-text-field
              outlined
              dense
              label="حجم ورودی / خروجی"
              v-model="edit.amount"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مبدا / مقصد"
              v-model="edit.orgDes"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="edit.note"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editExchangeModal = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editSubmit(selectedExchange)">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDeleteDialog"
      max-width="500px"
      header-color="error"
    >
      <v-card>
        <v-card-title>
          <h4>حذف {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>
              آیا از حذف {{ selectedExchange.type }} با مشخصات زیر مطمئن هستید؟
            </p>
            <p style="font-weight: bold; color: red">
              این کار غیر قابل برگشت است!
            </p>
            <b-table
              small
              responsive
              show-empty
              id="detailsTable"
              :items="[selectedExchange]"
              :fields="delExchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmDeleteDialog = false">
            لغو
          </v-btn>
          <v-btn
            class="text-white"
            color="red"
            @click="doDelete(selectedExchange)"
          >
            حذف کن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی "
              v-model="editingMaterial.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی "
              dir="ltr"
              v-model="editingMaterial.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="editingMaterial.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="editingMaterial.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="واحد اندازه‌گیری"
              v-model="editingMaterial.measurementUnit"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="editingMaterial.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="editingMaterial.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="editingMaterial.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="editingMaterial.length"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="موجودی"
              v-model="editingMaterial.sum"
              type="number"
              disabled
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="editingMaterial.description"
            ></v-textarea>
            <v-text-field
              outlined
              dense
              label="بازه اخطار"
              v-model="editingMaterial.alertRange"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="بازه بحران"
              v-model="editingMaterial.crisisRange"
              type="number"
            ></v-text-field>

            <b-form-group label="تاریخ انقضا ">
              <date-picker
                v-model="editingMaterial.expireDate"
                :editable="true"
              ></date-picker>
            </b-form-group>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="editDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editItem()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Axios from "axios";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { link } from "fs";
import router from "../../router";
import moment from "moment-jalaali";
import { setTimeout } from "timers";
import Loading from "../../components/Loading.vue";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  data() {
    return {
      guide: false,
      type: Var.allTypes[1],
      editDialog: false,
      itemInfo: {},
      editingMaterial: {},
      warehouses: [],
      fieldsFull: [
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        // { key: "sum", label: "کل موجودی" },
        { key: "name", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "sum", label: "موجودی" },
        { key: "measurementUnit", label: "واحد اندازه‌گیری" },
        { key: "description", label: "توضیحات" },
        { key: "alertRange", label: "بازه اخطار" },
        { key: "crisisRange", label: "بازه بحران" },
        { key: "expireDate", label: "تاریخ انقضا" },
      ],
      moment: moment,
      currentPage: 1,
      perPage: 10,
      filter: null,
      fields: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ" },
        { key: "showName", label: "نام فایل" },
        { key: "uploaderName", label: "نام فرد آپلودکننده" },
        { key: "operation", label: "دریافت" },
      ],
      isBusy: false,
      role: "",
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "operation", label: "عملیات" },
      ],
      allExchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "warehouseName", label: "انبار مربوطه" },
        { key: "operation", label: "عملیات" },
      ],
      delExchangesFields: [
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "warehouseName", label: "انبار مربوطه" },
      ],
      currentExchangePage: 1,
      ExchangePerPage: 10,
      selectedExchange: {},
      selectedExchangeWarehouse: "",
      confirmDeleteDialog: false,
      editExchangeModal: false,
      edit: {},
    };
  },
  components: {
    VueSlider,
    datePicker: VuePersianDatetimePicker,
   
    Loading,
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openEditDialog() {
      this.editingMaterial = JSON.parse(JSON.stringify(this.itemInfo));
      this.editDialog = true;
    },
    editItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.$route.params.id,
          name: this.editingMaterial.name,
          identifierFa: this.editingMaterial.identifierFa,
          identifierEn: this.editingMaterial.identifierEn,
          description: this.editingMaterial.description,
          technicalDescription: this.editingMaterial.technicalDescription,
          material: this.editingMaterial.material,
          coating: this.editingMaterial.coating,
          dimensionStandard: this.editingMaterial.dimensionStandard,
          diameter: this.editingMaterial.diameter,
          length: this.editingMaterial.length,
          place: this.editingMaterial.place,
          suppliersList: this.editingMaterial.suppliersList,
          expireDate: this.editingMaterial.expireDate,
          measurementUnit: this.editingMaterial.measurementUnit,
          alertRange: this.editingMaterial.alertRange,
          crisisRange: this.editingMaterial.crisisRange,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getItemInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.itemInfo = res.data;
            this.vLoading = false;
            this.isBusy = false;
            Axios.post(
              this.baseUrl + "/ppkpms/warehouse/warehouses/getByType",
              {
                warehouseTypeId: this.itemInfo.warehouseTypeId,
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("token"),
                },
              }
            )
              .then((res2) => {
                if (res2.status == 200) {
                  this.warehouses = res2.data;
                } else {
                  const title = (
                    <div>
                      <h5>خطا </h5>
                      <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                    </div>
                  );
                  this.toast(title, "error");
                }
              })
              .catch((err2) => {
                this.toast("خطا: " + err2.response.data, "error");
              });
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.isBusy = false;
          this.toast(err.response.data, "error");
        });
    },
    submitCorrection(exchange, warehouseId) {
      this.selectedExchange = exchange;
      this.selectedExchangeWarehouse = warehouseId;
      this.editExchangeModal = true;
      this.edit = JSON.parse(JSON.stringify(exchange));
      try {
        let myDateTime = this.edit.date.split(" ");
        this.edit.date = myDateTime[0];
        this.edit.time = myDateTime[1];
      } catch (error) {
        this.edit.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.edit.time = moment(new Date()).format("HH:mm");
      }
    },
    editSubmit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/editTransaction",
        {
          transactionId: exchange.id,
          amount: this.edit.amount,
          date: this.edit.date + " " + this.edit.time,
          orgDes: this.edit.orgDes,
          note: this.edit.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    approve(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/confirmation",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    askDelete(exchange) {
      this.selectedExchange = exchange;
      this.confirmDeleteDialog = true;
    },
    doDelete(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/delete",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("حذف با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    needEdit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/needEdit",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("ویرایش با موفقیت انجام شد", "success");
            this.getItemInfo();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.isBusy = true;
    this.vLoading = true;
    this.role = localStorage.getItem("role");
    this.getItemInfo();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.orderInfoTable {
  border-radius: unset;
}
</style>
